import '../styles/App.css';

import React, { Component } from 'react'
import { connect } from 'react-redux';
import { withRouter } from 'react-router5'

import Nav from './Nav'
import Main from './Main'
import ProfileBar from './Profile'
import Login from '../login/login'
import Logout from '../login/logout'
import initI18n from '../lang/i18n'
import Pin from "../login/pin";
import { importConverseJS } from "../IM/IM";

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {theme: 'light', logout: false};
    this.portal_ref = React.createRef();
    initI18n(this.props.lang);
  }

  setTheme(){}

  setLogoutModal(open) {
    this.setState({logout: open})
  }

  render() {

    const { user, status } = this.props.current_user;

    /*
    // PIN: deactivate
    const pin = this.props.pin;
    const askPin = this.props.askPin;
    */

    const currentTheme = this.props.currentTheme;



    if (!user) {
      if (status === "rejected") {
        // router's route may not be initialized on first call?
        const s = this.props.router.getState();

        if ((s && s.name !== 'login') || window.location.pathname !== '/login') {
          this.props.router.navigate('login');
        }

        return <div className={`App ${currentTheme}`}>
          <header className="App-header">
          </header>
          <main><Login router={this.props.router} /></main>
        </div>
      }
      return <div className={`App ${currentTheme}`}>
        <header className="App-header">
        </header>
        <main>Loading...</main>
      </div>
    }
    /*
    // PIN: deactivate
    if(pin==="" || askPin){
      this.props.router.navigate('pin');
      return <div className={`App ${currentTheme}`}>
        <header className="App-header">
        </header>
        <main><Pin router={this.props.router} /></main>
      </div>
    }
    */

    const pinRoutes = [this.props.router.buildPath("pin"), this.props.router.buildPath("setPin")];
    if (pinRoutes.includes(window.location.pathname)) {
      return( <div className={`App ${currentTheme}`}>
        <div className="main-column">
          <main>
            <Main portal_ref={this.portal_ref} />
          </main>
        </div>
      </div>);
    }

    user && importConverseJS(user);

    return (
      <div className={`App ${currentTheme}`}>
        <Nav user={user} onLogout={() => this.setLogoutModal(true)} />
        <div className="main-column">
          {/*<FilterDays />*/}
          <ProfileBar portal_ref={this.portal_ref} />
          <main>
            <Main portal_ref={this.portal_ref} />
          </main>
        </div>
        { this.state.logout &&
          <Logout router={this.props.router} onClose={() => this.setLogoutModal(false)} /> }
      </div>
    );
  }
}

// PIN: deactivate (remove pin:state.pin.value)
const mapStateToProps = (state) => ({current_user: state.current_user,currentTheme:state.theme.value,lang:state.lang.value});

export default withRouter(connect(mapStateToProps, null)(App));
